import {
  ChangeDetectionStrategy,
  Component,
  ElementRef,
  afterNextRender,
  inject,
  input,
  output,
  signal,
  viewChild,
} from '@angular/core';

import { GoogleMapsLoaderService } from '@core/services/google-maps-loader.service';
import { XSpinnerComponent } from '../x-spinner/x-spinner.component';

@Component({
  selector: 'x-google-map',
  standalone: true,
  imports: [XSpinnerComponent],
  templateUrl: './x-google-map.component.html',
  styleUrl: './x-google-map.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class XGoogleMapComponent {
  center = input.required<google.maps.LatLngLiteral>();
  zoom = input<number>(8);
  mapId = input<string | undefined>(undefined);
  mapReady = output<google.maps.Map>();

  protected readonly loading = signal(true);

  private readonly mapContainer = viewChild.required<ElementRef<HTMLElement>>('mapContainer');
  private readonly mapsLoader = inject(GoogleMapsLoaderService);

  constructor() {
    afterNextRender(() => this.initMap());
  }

  private async initMap(): Promise<void> {
    await this.mapsLoader.load();

    const map = new google.maps.Map(this.mapContainer().nativeElement, {
      center: this.center(),
      zoom: this.zoom(),
      mapId: this.mapId() || undefined,
      zoomControl: true,
      fullscreenControl: true,
      mapTypeControl: false,
      streetViewControl: false,
      gestureHandling: 'greedy',
      minZoom: 3,
      maxZoom: 18,
    });

    this.loading.set(false);
    this.mapReady.emit(map);
  }
}
